/**
 * Basic status enum values
 */
export enum BasicStatusType {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
